import { ACE_CONFIG, AceConfigInterface, AceModule } from 'ngx-ace-wrapper';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FroalaModule } from '@component/froala-editor';

import { FlowMaterialModule } from '@app/flow-material.module';
import { RichtextEditorComponent } from './richtext-editor.component';

const DEFAULT_ACE_CONFIG: AceConfigInterface = {
  navigateWithinSoftTabs: true,
  tabSize: 2,
  useSoftTabs: true,
  wrap: true
};

@NgModule({
  declarations: [RichtextEditorComponent],
  exports: [RichtextEditorComponent],
  imports: [AceModule, CommonModule, FlowMaterialModule, FroalaModule],
  providers: [
    {
      provide: ACE_CONFIG,
      useValue: DEFAULT_ACE_CONFIG
    }
  ]
})

export class RichtextEditorModule {}
